<script setup lang="ts">
/**
 * The Dometry mark (a D whose bowl holds a second arch) on a walnut tile, or
 * with `full` the whole DOMETRY logotype on a walnut pill. The pill's first
 * square is the mark, so narrowing it (the collapsed sidebar) leaves the D.
 */
import { LOGO_HEIGHT, MARK, WORDMARK } from '../brand.ts';

/** The logotype's width as a multiple of its height (the pill's natural width). */
const RATIO = WORDMARK.width / LOGO_HEIGHT;

withDefaults(defineProps<{ size?: 'md' | 'lg'; full?: boolean }>(), { size: 'md', full: false });
</script>

<template>
  <span
    class="logo"
    :class="{ 'logo--lg': size === 'lg', 'logo--full': full }"
    :style="{ '--logo-ratio': RATIO }"
    aria-hidden="true"
  >
    <svg
      class="logo__art"
      :viewBox="`0 0 ${full ? WORDMARK.width : LOGO_HEIGHT} ${LOGO_HEIGHT}`"
      preserveAspectRatio="xMinYMid meet"
    >
      <g
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2.8"
      >
        <path :d="MARK.d" />
        <path :d="MARK.arch" stroke-width="2.2" />
        <path v-if="full" class="logo__rest" :d="WORDMARK.path" />
      </g>
    </svg>
  </span>
</template>
